const awsmobile = {
    aws_project_region: 'ap-south-1',
    aws_cognito_identity_pool_id: 'ap-south-1:d2e3b4e8-b6a8-4e6a-8881-ac7e9401f325',
    aws_cognito_region: 'ap-south-1',
    aws_user_pools_id: 'ap-south-1_lJLdnZ4A9',

    aws_user_pools_web_client_id: 'xxxxxxxxxxxxxxxxxxxxxxxxxx',

    oauth: {},
    aws_appsync_graphqlEndpoint: 'https://xxxxxx.appsync-api.us-east-1.amazonaws.com/graphql',
    aws_appsync_region: 'ap-south-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    // ... other configuration values
};

export default awsmobile;